import { injectGlobal } from 'styled-components';

import { grey10, navy } from '@zocdoc/branding/colors';
import { FontFamily } from '../typography';

import '../styles/fonts/KievitSlab-Book.woff2';
import '../styles/fonts/SharpSans-No1-Medium.woff2';
import '../styles/fonts/SharpSans-No1-Semibold.woff2';
import '../styles/fonts/SharpSans-No1-Bold.woff2';

import '../styles/fonts/KievitSlab-Book.woff';
import '../styles/fonts/SharpSans-No1-Medium.woff';
import '../styles/fonts/SharpSans-No1-Semibold.woff';
import '../styles/fonts/SharpSans-No1-Bold.woff';

/*
 * CSS Reset
 *
 * http://meyerweb.com/eric/tools/css/reset/
 * v2.0 | 20110126
 * License: none (public domain)
 */
injectGlobal`
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }

    // HTML5 display-role reset for older browsers
    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }

    ol, ul {
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    a {
        color: inherit;
        text-decoration: inherit;
    }

    button {
        border-radius: 0;
    }

    [hidden] {
      display: none !important;
    }

    // hide built in input clear button in IE
    input[type=text]::-ms-clear {
        display: none;
    }
`;

const PATIENT_WEB_APP_CF_URL = 'https://d1uhlocgth3qyq.cloudfront.net';

/*
 * former contents of styles/typography.fonts.scss
 */
injectGlobal`
    @font-face {
        font-display: fallback;
        font-family: "kievit-slab-book"; //serif body copy
        src: url("${PATIENT_WEB_APP_CF_URL}/fonts/KievitSlab-Book.woff2") format("woff2"),
             url("${PATIENT_WEB_APP_CF_URL}/fonts/KievitSlab-Book.woff") format("woff");
    }

    @font-face {
        font-display: fallback;
        font-family: "sharp-sans-medium"; // sans serif headline font
        src: url("${PATIENT_WEB_APP_CF_URL}/fonts/SharpSans-No1-Medium.woff2") format("woff2"),
             url("${PATIENT_WEB_APP_CF_URL}/fonts/SharpSans-No1-Medium.woff") format("woff");
    }

    @font-face {
        font-display: fallback;
        font-family: "sharp-sans-semibold";
        src: url("${PATIENT_WEB_APP_CF_URL}/fonts/SharpSans-No1-Semibold.woff2") format("woff2"),
             url("${PATIENT_WEB_APP_CF_URL}/fonts/SharpSans-No1-Semibold.woff") format("woff");
    }

    @font-face {
        font-display: fallback;
        font-family: "sharp-sans-bold"; // sans serif headline font
        src: url("${PATIENT_WEB_APP_CF_URL}/fonts/SharpSans-No1-Bold.woff2") format("woff2"),
             url("${PATIENT_WEB_APP_CF_URL}/fonts/SharpSans-No1-Bold.woff") format("woff");
    }
`;

/*
 * foundation styles from @zocdoc/patient-web-layout/lib/Layout/global.scss
 * + fixing the FF extra button spacing
 */
injectGlobal`
    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    body {
        background-color: ${grey10};
        color: ${navy};
        font-family: ${FontFamily.KievitSlabBook};
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    button::-moz-focus-inner {
        padding: 0;
        border: 0;
    }

    img {
        // Grid defaults to get images and embeds to work properly
        max-width: 100%;
        height: auto;
        -ms-interpolation-mode: bicubic;

        // Get rid of gap under images by making them display: inline-block; by default
        display: inline-block;
        vertical-align: middle;
    }

    main {
        display: block; // IE
    }
`;

/*
 * Fix react-click-outside package for iOS
 * https://www.npmjs.com/package/react-click-outside#not-working-on-ios
 */
injectGlobal`
    @media (-moz-touch-enabled: 1), (pointer:coarse) {
        body {
            cursor: pointer;
            -webkit-tap-highlight-color: transparent;
        }
    }
`;
